import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeSharedProfileHeader(): Provider {
  return provideTranslocoScope({
    scope: 'profile-header',
    alias: 'ph',
    loader: i18nLoader,
  });
}
